<div class="container">
  <div class="row">
    <div class="col-sm-9 col-md-7 col-lg-4 col-md-offset-4 mx-auto mb-20">
      <div class="admin-form-container">
        <div class="title">
          <h1 class="title-heading">{{ title | translate }}</h1>
        </div>
        <div class="admin-form" *ngIf="errorMessage">
          <div class="form-group alert alert-danger">
            {{ errorMessage }}
          </div>
        </div>
        <div *ngIf="!errorMessage">
          <div class="login-link text-center mt-2">
            <a class="link primary" [href]="getAdminLink()">
              {{ 'Login to your Admin account to start impersonate users' | translate }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
